import { mapGetters } from 'vuex';
import motime from '../../../common/utilities/motime';
import dppNav from '@/dpp/components/propertynav/dpp-nav.vue';
import dppButton from '@/dpp/components/propertybutton/dpp-button/dpp-button.vue';
import SplitTreatments from '@/common/components/split/SplitTreatments.vue';

export default {
    name: 'propertyTitle',
    inject: ['$eventBus', 'split'],
    components: {
        dppNav,
        dppButton,
        SplitTreatments
    },
    props: {
        rentalObj: {
            type: Object,
            default: null,
        },
    },
    computed: {
        ...mapGetters('glb', ['glb', 'getSplit']),
        ...mapGetters('dpp', ['dpp', 'getEstimatePriceRange', 'getEstimateInfo', 'getMortgagePerMonth']),
        hidePricePreArea() {
            const compliance = this.getComplianceMethod()();
            return compliance[0] && compliance[0].rule && compliance[0].rule.indexOf('hidePricePreArea') >= 0;
        },
        hideEstMonthCost() {
            const compliance = this.getComplianceMethod()();
            return compliance[0] && compliance[0].rule && compliance[0].rule.indexOf('hideEstMonthCost') >= 0;
        },
        showAvmDisclaimer1() {
            this.$eventBus.$emit('dialog-center', { name: 'dppPopEst', opt: {}, trigger: this.$options.name });
        },
        showAvmDisclaimer2() {
            this.$eventBus.$emit('dialog-center', { name: 'dppPopAvm', opt: {}, trigger: this.$options.name });
        },
        showAvmDisclaimer3() {
            this.$eventBus.$emit('property-pop-avm-disclaimer3', this.$options.name);
        },
        showIncentive() {
            return !this.glb.agent.id && !this.dpp.listingByMovoto;
        },
        hideAvmInfo() {
            return this.dpp.listingByMovoto && this.dpp.avmInfo && this.dpp.avmInfo.valuation < this.dpp.listPrice;
        },
        showApproveButton() {
            return !this.hideApprovalButton;
        },
        hideApprovalButton() {
            const priceLessThan100k = this.dpp.price <= 100000;
            const isLandMobile = ['LAND', 'MOBILE'].includes(this.dpp.propertyType);
            const mortgageCTAbelow100K =
                this.dpp.houseRealStatus === 'ACTIVE' && this.dpp.price >= 50000 && this.dpp.price < 100000 && ['SINGLE_FAMILY_HOUSE', 'CONDO'].includes(this.dpp.propertyType);
            if (['MOBILE'].includes(this.dpp.propertyType) || mortgageCTAbelow100K) {
                return false;
            }
            if (!this.dpp.isActive) {
                return false;
            }
            return (priceLessThan100k || isLandMobile) && !(this.dpp.houseRealStatus === 'ACTIVE' && priceLessThan100k && isLandMobile);
        },
        getPrice() {
            return this.showEstPrice && this.getEstimateInfo ? this.getEstimateInfo.value : this.dpp.price;
        },
        applyObj() {
            var betterLink = ['MA', 'HI', 'NH', 'NV'].indexOf(this.dpp.geo.state) === -1;
            var isLandMobile = this.dpp.houseRealStatus === 'ACTIVE' && this.dpp.price <= 100000 && ['LAND', 'MOBILE'].includes(this.dpp.propertyType);
            const obj = {
                cta: this.dpp.isActive ? this.molang('dpp.propertyDetails.getPreapproved') : this.molang('dpp.propertyDetails.getLowerPayment'),
                utmcta: this.dpp.isActive ? 'apply' : 'refinance',
                url: this.dpp.isActive ? (isLandMobile ? 'prequalifylandmobile' : betterLink ? 'betterpreapproved' : 'preapprove') : 'refinance',
            };
            return obj;
        },
        hasSoldPrice() {
            if(this.dpp.isActive) return true;
            return !!this.dpp.closePrice;
        }
    },
    data() {
        return {
            subText: '',
            dateText: '',
            rawPrice: '',
            updatePriceByAVM: '',
            showChangePrice: 0,
            showEstPrice: false,
        };
    },
    methods: {
        ...mapGetters('glb', ['getComplianceMethod']),
        async showForm(applyObj) {
            if (!applyObj) {
                console.error('Invalid applyObj provided to showForm');
                return;
            }
            const TREATMENT_EXPERIMENT = 'movoto-cpc-apply-cw-9238';
            const cta = applyObj.cta;
            const TREATMENT_CONFIG = {
                on12: {
                    utm_campaign: 'getpreapprovedATF_sub100',
                    cta: cta,
                    ga: 'partner_mortgage_listings_session_sub100k',
                },
                on13: {
                    utm_campaign: 'Get Preapproved ATF_inactive',
                    cta: cta,
                    ga: 'partner_mortgage_listings_session',
                    desc: 'getpreapproved',
                },
                on9: {
                    utm_campaign: 'getpreapprovedATF',
                    cta: cta,
                    ga: 'partner_mortgage_listings_session',
                    desc: 'getpreapproved',
                },
            };

            try {
                const treatment = await this.split.fetchTreatments([TREATMENT_EXPERIMENT], {
                    attributes: {
                        movoto_geo_zipcode: this.dpp.geo.zipcode,
                        movoto_geo_state: this.dpp.geo.state,
                        movoto_listing_price: this.dpp.price,
                        movoto_listing_type: this.dpp.propertyType,
                        movoto_listing_status: this.dpp.houseRealStatus,
                    },
                });

                const treatmentKey = treatment[TREATMENT_EXPERIMENT];
                const opt = TREATMENT_CONFIG[treatmentKey];

                if (opt?.utm_campaign && opt?.ga && opt?.cta) {
                    this.$eventBus.$emit('dialog-center', {
                        name: 'mrcMortgageRates',
                        trigger: this.$options.name,
                        opt: {
                            showNormalMrc: true,
                            ...opt,
                        },
                    });
                    return;
                }
                if (this.getSplit('movoto-cpc-apply-cw-9238', 'on15')) {
                    applyObj.utmcta = 'apply';
                }
                this.show3rdPartyForm(applyObj.utmcta, applyObj.url, cta);
            } catch (error) {
                console.error('Error in showForm:', error);
                this.show3rdPartyForm(applyObj.utmcta, applyObj.url, cta);
            }
        },
        show3rdPartyForm(utmcta, url, cta, isAppendUtmCta = false) {
            //overwrite pid CW-8100
            var pid;
            if (this.dpp.isActive && this.dpp.price <= 100000) {
                if (this.dpp.propertyType === 'MOBILE') {
                    pid = 'movoto_mobile';
                } else if (this.dpp.propertyType === 'LAND') {
                    pid = 'movoto_land';
                }
            }
            this.$eventBus.$emit('eventbus-pop-3rdparty', {
                pid: pid,
                id: utmcta,
                url: url,
                zipcode: this.dpp.geo.zipcode,
                price: this.dpp.price,
                propertyType: this.dpp.propertyType,
                houseRealStatus: this.dpp.houseRealStatus,
                trigger: this.$options.name,
                cta: cta,
                imageUrl: this.dpp.tnImgPath,
                listingUrl: (this.dpp.path && `${this.glb.appUrl}${this.dpp.path}`) || '',
                isAppendUtmCta: isAppendUtmCta,
            });
        },
        showMorgageSection() {
            this.$eventBus.$emit('eventbus-open-mortgage', { openMorgageFlag: true });
        },
        updateTitle() {
            this.subText = '';
            this.dateText = '';
            var code = this.dpp.houseRealStatus;
            this.showChangePrice = this.dpp.showPriceChange;
            this.showEstPrice = this.dpp.isEstPrice;
            if (this.dpp.showAsPR) {
                this.showChangePrice = 0;
                this.showEstPrice = !this.dpp.isRentals;
                return (this.subText = this.molang('dpp.dppTitle.publicRecord'));
            }
            switch (code) {
                case this.glb.propertyStatus.forRent:
                    this.subText = this.molang('dpp.dppTitle.rent');
                    break;
                case this.glb.propertyStatus.active:
                    this.subText = this.molang('dpp.dppTitle.sale');
                    if (this.dpp.isCommingSoonListing && !this.dpp.hideDaysOnMarket) {
                        this.subText = `${this.molang('dpp.dppTitle.coming')}${
                            this.dpp.listDate && this.dpp.listDate != '—' && this.dpp.listDate > new Date() ? ` - ${motime.formatDate(this.dpp.listDate, { year: undefined, month: 'numeric' })}` : ''
                        }`;
                    }
                    if (this.dpp.isNew || this.dpp.createdAt) {
                        if (this.dpp.isNew) {
                            this.dateText = this.molang('dpp.dppTitle.new');
                        }
                        if (this.dpp.createdAt && !this.dpp.isCommingSoonListing && !this.dpp.hideDaysOnMarket) {
                            this.dateText += ' ' + this.dpp.createTimeDisplay;
                        }
                    }
                    break;
                case this.glb.propertyStatus.pending:
                    if (this.dpp.showPendingBackupOffer) {
                        this.subText = this.dpp.listingStatusDisplayName;
                    } else {
                        this.subText = this.dpp.activeUnderContract ? this.molang('dpp.dppTitle.contract') : this.molang('dpp.dppTitle.pending');
                    }
                    break;
                case this.glb.propertyStatus.sold:
                    this.subText = `${this.molang('dpp.dppTitle.sold')} `;
                    if (this.dpp.soldDate && !this.dpp.hideDaysOnMarket) {
                        var text = this.dpp.soldTimeDisplay ? ` in ${this.dpp.soldTimeDisplay}` : '';
                        this.dateText += ` on ${motime.formatDate(this.dpp.soldDate)}`;
                        this.subText += text;
                    }
                    if (this.dpp.price && this.dpp.isEstPrice) {
                        this.subText = this.molang('dpp.dppTitle.offMarket');
                    }
                    break;
                case this.glb.propertyStatus.removed:
                case this.glb.propertyStatus.offMarket:
                    this.showChangePrice = 0;
                    this.showEstPrice = !this.dpp.isRentals;
                    this.subText = this.molang('dpp.dppTitle.offMarket');
                    break;
            }
        },
        popMapView() {
            this.$eventBus.$emit('property-pop-map', { popMapTypeId: 0, popStreetView: false });
        },
    },
    created() {
        this.updateTitle();
    },
    mounted() {
        const that = this;
        this.$eventBus.$on('show-dpp-rental-pop-link', function (data) {
            that.show3rdPartyForm(data);
        });
    },
    beforeUnmount() {
        this.$eventBus.$off('show-dpp-rental-pop-link');
    },
};
